module.exports = __webpack_public_path__ + "fonts/Roboto-700-greek-ext51.eb17caf.woff2";